<div class="soft-top-container border-primary-200 border-b">
  <soft-date-navigator
    [date]="date()" (dateChange)="dateChange($event)"
  ></soft-date-navigator>
</div>

<router-outlet></router-outlet>
